import React, { useState, useRef } from "react";
import { ReCaptcha } from "react-recaptcha-google";
import { connect } from "react-redux";
import { selectUserState } from "../../selectors/application";
import PrimaryButton from "../../elements/primary-button";
import Input from "../../elements/input";
import Dropdown from "../../elements/dropdown";
import Textarea from "../../elements/textarea";
import BodyText from "../../elements/body-text";
import PropTypes from "prop-types";
import "./style.scss";

const ContactSupportForm = ({
  user,
  //  captcha,
  countryTip,
  subjectTip,
  emailTipText,
  countryRequiredError,
  subjectRequiredError,
  messageRequiredError,
  firstnameLabel,
  lastnameLabel,
  firstnameRequired,
  lastnameRequired,
  emailRequiredError,
  emailErrorTipText,
  subject,
  countries,
  countryVisible,
  messageTipText,
  hasCaptcha,
  captchaSiteKey,
  hasError,
  errorMessage,
  button,
  disclaimer,
  onSubmitForm = () => { }
}) => {
  const [captchaValidated, setCaptchaValidated] = useState(!hasCaptcha);
  // const [captchaIsValid, setCapthchaIsValid] = useState();
  const [emailEntered, setEmailEntered] = useState(user?.email);
  const [emailEnteredIsValid, setEmailEnteredIsValid] = useState(true);

  const [firstnameEntered, setFirstnameEntered] = useState(user?.firstName);
  const [firstnameShowError, setFirstnameShowError] = useState();
  const [lastnameEntered, setLastnameEntered] = useState(user?.lastName);
  const [lastnameShowError, setLastnameShowError] = useState();
  const [emailEnteredShowError, setEmailEnteredShowError] = useState(false);
  const [emailErrorMessage, setEmailErrorMessage] = useState();
  const [subjectSelected, setSubjectSelected] = useState();
  const [subjectShowError, setSubjectShowError] = useState();
  const [countrySelected, setCountrySelected] = useState();
  const [countryShowError, setCountryShowError] = useState();
  const [messageEntered, setMessageEntered] = useState();
  const [messageShowError, setMessageShowError] = useState();

  // const [termsAccepted, setTermsAccepted] = useState();
  // const [termsAcceptedShowError, setTermsAcceptedShowError] = useState();

  let captcha;
  const captchaContainer = useRef();

  const onLoadRecaptcha = () => captcha && captcha.reset();

  const verifyCallback = (recaptchaToken, grecaptcha) => {
    // Here you will get the final recaptchaToken!!!
    getCaptchFrame().style = "";

    if (recaptchaToken) {
      setCaptchaValidated(true);
    } else {
      grecaptcha.reset();
    }
  };

  const onInputChange = (event, isValid) => {
    setEmailEntered(event.target.value);
  };

  const onInputEmailBlur = (evt, isValid) => {
    setEmailEntered(evt.target.value);
    if (evt.target.value) {
      setEmailEnteredIsValid(isValid);
    }
  };

  const onfirstnameChange = event => {
    setFirstnameEntered(event.target.value);
  };

  const onLastnameChange = event => {
    setLastnameEntered(event.target.value);
  };

  const onSubjectDropdownChange = value => {
    setSubjectSelected(value);
  };

  const onCountryDropdownChange = value => {
    setCountrySelected(value);
  };

  const onTextAreaChange = event => {
    setMessageEntered(event.target.value);
  };

  // const onTermsCheckboxChange = event => {
  //   setTermsAccepted(event.target.checked);
  // };

  const submitFormIsValid = () => {
    return emailEnteredIsValid && firstnameEntered && lastnameEntered && ((countrySelected && countryVisible) || !countryVisible) && subjectSelected && messageEntered && ((captchaValidated && hasCaptcha) || !hasCaptcha);
  };

  const onSubmitFormData = event => {
    if (submitFormIsValid()) {
      let data = {
        firstname: firstnameEntered,
        lastname: lastnameEntered,
        email: emailEntered,
        country: countrySelected,
        subject: subjectSelected,
        message: messageEntered
      };
      onSubmitForm(event, data);
    } else {
      if (!countrySelected) {
        setCountryShowError(true);
      }
      if (countrySelected.code === 'default') {
        setCountryShowError(true);
      }

      if (!firstnameEntered) {
        setFirstnameShowError(true);
      }

      if (!lastnameEntered) {
        setLastnameShowError(true);
      }

      if (!emailEntered) {
        setEmailEnteredShowError(true);

        setEmailErrorMessage(emailRequiredError.value);
      } else if (!emailEnteredIsValid) {
        setEmailErrorMessage(emailErrorTipText.value);
        setEmailEnteredIsValid(true);
      }

      if (!subjectSelected) {
        setSubjectShowError(true);
      }
      if (subjectSelected?.code === 'default') {
        setSubjectShowError(true);
      }

      if (!messageEntered) {
        setMessageShowError(true);
      }

      if (!captchaValidated && hasCaptcha) {
        getCaptchFrame().style = "padding: 2px 1px 1px 2px; background: red;";
      }
    }
  };

  const getCaptchFrame = () => {
    return captchaContainer.current.querySelector(".captcha iframe");
  };

  // const handleSubmit = event => {
  //   event.preventDefault();
  //   if (captchaValidated) setCapthchaIsValid(true);
  //   else {
  //     getCaptchFrame().style = "padding: 2px 1px 1px 2px; background: red;";
  //   }
  // };

  return (
    <form
      className={"contact-support-form"}
    //  onSubmit={event => handleSubmit(event)}
    >
      <Input
        {...{
          label: firstnameLabel.value,
          value: firstnameEntered,
          maxLength: 25,
          warningMessage: firstnameRequired.value,
          showError: firstnameShowError,
          onChange: event => onfirstnameChange(event),
          onFocus: () => setFirstnameShowError(false)
        }}
      />
      <Input
        {...{
          label: lastnameLabel.value,
          warningMessage: lastnameRequired.value,
          value: lastnameEntered,
          maxLength: 25,
          showError: lastnameShowError,
          onChange: event => onLastnameChange(event),
          onFocus: () => setLastnameShowError(false)
        }}
      />
      <Input
        {...{
          label: emailTipText.value,
          value: emailEntered,
          warningMessage: emailErrorMessage,
          showError: emailEnteredShowError || !emailEnteredIsValid,
          type: "email",
          onChange: (event, isValid) => onInputChange(event, isValid),
          onFocus: () => setEmailEnteredShowError(false),
          onBlur: (evt, isValid) => onInputEmailBlur(evt, isValid)
        }}
      />

      {subject && (
        <Dropdown
          className="subject"
          {...{
            ...subject,
            placeholder: subjectTip?.value,
            warningMessage: subjectRequiredError?.value,
            showError: subjectShowError,
            onChange: value => onSubjectDropdownChange(value),
            onFocus: () => setSubjectShowError(false)
          }}
        />
      )}

      {countryVisible && (
        <Dropdown
          className="country"
          {...{
            ...countries,
            placeholder: countryTip.value,
            warningMessage: countryRequiredError.value,
            showError: countryShowError,
            onChange: value => onCountryDropdownChange(value),
            onFocus: () => setCountryShowError(false)
          }}
        />
      )}

      <Textarea
        {...{
          label: messageTipText?.value,
          warningMessage: messageRequiredError?.value,
          showError: messageShowError,
          onChange: event => onTextAreaChange(event),
          onFocus: () => setMessageShowError(false)
        }}
      />

      {hasCaptcha && (
        <div className="captcha" ref={captchaContainer}>
          <ReCaptcha
            ref={el => {
              captcha = el;
            }}
            size="normal"
            data-theme="dark"
            theme="dark"
            render="explicit"
            sitekey={captchaSiteKey}
            onloadCallback={onLoadRecaptcha}
            verifyCallback={captchaToken => {
              verifyCallback(captchaToken, captcha);
            }}
          />
        </div>
      )}

      {errorMessage && hasError && (
        <div
          className="error-message"
          dangerouslySetInnerHTML={{
            __html: errorMessage
          }}
        />
      )}

      {button != null && (
        <PrimaryButton
          {...{
            ...button,
            callback: event => onSubmitFormData(event)
          }}
        />
      )}
      {disclaimer.value !== "" && <BodyText html={disclaimer.value} className="disclaimer" />}
    </form>
  );
};

ContactSupportForm.propTypes = {
  countryTip: PropTypes.object,
  subjectTip: PropTypes.object,
  emailTipText: PropTypes.object,
  countryRequiredError: PropTypes.object,
  subjectRequiredError: PropTypes.object,
  messageRequiredError: PropTypes.object,
  firstnameLabel: PropTypes.object,
  lastnameLabel: PropTypes.object,
  firstnameRequired: PropTypes.object,
  lastnameRequired: PropTypes.object,
  emailRequiredError: PropTypes.object,
  emailErrorTipText: PropTypes.object,
  subject: PropTypes.object,
  countries: PropTypes.object,
  countryVisible: PropTypes.bool,
  messageTipText: PropTypes.object,
  hasCaptcha: PropTypes.bool,
  captchaSiteKey: PropTypes.string,
  hasError: PropTypes.bool,
  errorMessage: PropTypes.object,
  button: PropTypes.object,
  disclaimer: PropTypes.object,
  onSubmitForm: PropTypes.func
};

const mapStateToProps = state => ({
  user: selectUserState(state)
});
export default connect(mapStateToProps)(ContactSupportForm);
